import React from "react";
import { Select } from "@shopify/polaris";
import { useSortBy } from "@usereactify/search";

export const Sort = () => {
  const { sortOption, sortOptions, setSortOption } = useSortBy();

  const handleSelectChange = React.useCallback((value: string) => setSortOption(value), [setSortOption]);

  return (
    <Select
      label="Sort:"
      labelInline
      options={sortOptions.map((sortOption) => ({ label: sortOption.name, value: sortOption.handle }))}
      onChange={handleSelectChange}
      value={sortOption?.handle}
    />
  );
};
